import React, { memo } from 'react';

import { Button, Text, createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './EmbedFooter.styles';

const useStyles = createUseStyles(styles, 'EmbedFooter');

const resolveButtonType = (variant) => {
    if (variant === 'secondary' || variant === 'tertiary') return 'terciary';

    return undefined;
};

const EmbedFooter = memo(({ footer, onAction }) => {
    const classes = useStyles();

    if (!footer) return null;

    const { actions = [], statusText, summaryItems = [] } = footer;
    const hasActions = actions.length > 0;
    const hasSummary = summaryItems.length > 0;
    const hasStatus = Boolean(statusText);

    if (!hasActions && !hasSummary && !hasStatus) return null;

    return (
        <div className={classes.root}>
            {hasSummary ? (
                <div className={classes.summary}>
                    {summaryItems.map((item) => {
                        const itemKey = item.id || item.label || item.value;
                        const valueType = item.emphasis ? 'subtitle1' : 'body';
                        const itemClassName = item.emphasis
                            ? `${classes.summaryItem} ${classes.summaryItemEmphasis}`
                            : classes.summaryItem;

                        return (
                            <div className={itemClassName} key={itemKey}>
                                {item.label ? <Text type="caption">{item.label}</Text> : null}
                                <Text className={classes.value} type={valueType}>
                                    {item.value}
                                </Text>
                            </div>
                        );
                    })}
                </div>
            ) : null}
            <div className={classes.actions}>
                {hasStatus ? (
                    <Text className={classes.status} type="caption">
                        {statusText}
                    </Text>
                ) : null}
                {hasActions ? (
                    <div className={classes.buttons}>
                        {actions.map((action) => (
                            <Button
                                isDisabled={action.disabled}
                                isLoading={action.loading}
                                key={action.id || action.label}
                                onClick={() => {
                                    onAction?.(action.id, action.payload);
                                }}
                                type={resolveButtonType(action.variant)}
                            >
                                {action.label}
                            </Button>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
});

EmbedFooter.displayName = 'EmbedFooter';

export default EmbedFooter;
